import fetcher, { paramsFormer } from 'utils/fetcher';
import { SET_LOADING_HEADER } from 'utils/fetcher/contants';
import { ResponseFetcher } from 'utils/fetcher/types';
import { API_JORNADA, API_PRACTICA } from 'variables';

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getAlumnosCurso
export const getInformesHorasRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getInformeHoras?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getInformeHorasCountRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getInformeHorasCount?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getInformesHorasInstructorRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_PRACTICA}getInformeHorasInstructor?${paramsFormer(
      requestBody
    )}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getInformeHorasInstructorCountRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_PRACTICA}getInformeHorasInstructorCount?${Object.keys(
      requestBody
    )
      .map((key) => {
        return requestBody[key] !== undefined &&
          requestBody[key] !== null &&
          requestBody[key] !== '' &&
          requestBody[key] !== "''" &&
          requestBody[key].length !== 0 &&
          requestBody[key].toString()
          ? `${key}=${encodeURIComponent(requestBody[key])}`
          : `${key}`;
      })
      .join('&')}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getInformeInfraestructuraRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getInformeHabilitaciones?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getInformeInfraestructuraCountRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getInformeHabilitacionesCount?${paramsFormer(
      requestBody
    )}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getInformeProvinciasRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getFilterProvinciasInformes?${paramsFormer(
      requestBody
    )}`,
    options: {},
  });

export const getInformeFilterCursosRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getFilterCursoInformes?${paramsFormer(requestBody)}`,
    options: {},
  });

export const getInformeFilterAlumnosRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_JORNADA}getFilterAlumnosInformes?${paramsFormer(requestBody)}`,
    options: {},
  });
